import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { PartnerLogo } from 'app/components/partner-logo';
import { config } from 'app/config/config';
import { i18n } from 'app/i18n';
import { selectOrderRequests, selectPartners, selectSelectedAccount } from 'app/pages/order/redux/order-selector';
import { OrderRequestsUtils } from 'app/pages/order/utils/order-requests-utils';
import { RequestType } from 'app/pages/order/redux/model/order-request';
import { PartnerUtils } from 'app/pages/order/utils/partner-utils';

import { FooterExternalLink } from './footer-external-link';
import { FooterCustomerInformation } from './footer-customer-information';
import { StyledFooter, StyledLinks, StyledLogoAndLinksContainer } from './footer.styled';

const Footer: FunctionComponent = () => {
    const partners = useSelector(selectPartners);
    const orderRequests = useSelector(selectOrderRequests);
    const selectedAccount = useSelector(selectSelectedAccount);
    const loadingPartners = OrderRequestsUtils.isRequestPending(orderRequests, RequestType.GET_PARTNERS);
    const partner =
        !loadingPartners && selectedAccount?.partnerId
            ? PartnerUtils.getPartnerById(partners, selectedAccount.partnerId)
            : undefined;

    return (
        <StyledFooter>
            <FooterCustomerInformation />
            <StyledLogoAndLinksContainer>
                <PartnerLogo partner={partner} />
                <StyledLinks>
                    <FooterExternalLink
                        label={i18n.components.footer.linkToCustomerService}
                        url={config.CUSTOMER_SERVICE_URL}
                    />
                    <FooterExternalLink label={i18n.components.footer.linkToMainPage} url={config.MAIN_PAGE_URL} />
                    {partner?.siteUrl && <FooterExternalLink label={partner.name} url={partner.siteUrl} />}
                </StyledLinks>
            </StyledLogoAndLinksContainer>
        </StyledFooter>
    );
};

export { Footer };
